// @ts-nocheck
import React from 'react';
import {
  Platform,
  StatusBar,
  View,
  useWindowDimensions,
} from 'react-native';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { colorSwatches, styles } from '../styles';
import IconButton from '../components/IconButton';
import Text from '../components/Text';
import { Center, HStack } from 'native-base';
import PermissionsBanner from '../modules/More/components/PermissionsBanner';
import PendingApprovalsBadge from './PendingApprovalsBadge';
import { E_NAVIGATION_DESTINATIONS } from '../@types';
import { useAppSelector } from '../hooks/redux';
import { useFoldable } from '../hooks/useFoldable';

type NavbarProps = {
  title: string;
  navigation: {
    goBack: Function;
    canGoBack: () => boolean;
    navigate: Function;
  };
  backHandler?: Function;
};

const Navbar = ({ title, navigation, backHandler }: NavbarProps) => {
  const { width } = useWindowDimensions();
  const isAuthorized = !!(useAppSelector((state) => state.auth?.user?.id));
  const pendingOwnerApprovals = useAppSelector((state) =>
    state?.approvals?.approvals?.filter(
      approval => approval.residentApprovalStatus === 'Pending',
    ) ?? [],
  );
  const pendingOwnerApprovalsCount = pendingOwnerApprovals.length;
  const insets = useSafeAreaInsets();
  const isFoldable = useFoldable();
  const topInset =
    Platform.OS === 'android'
      ? Math.max(insets.top, StatusBar.currentHeight ?? 0)
      : insets.top;
  const headerTopPadding = topInset + (isFoldable ? 10 : 0);

  const onPress = () => {
    if (backHandler) {
      backHandler();
    } else {
      if (navigation.canGoBack()) {
        navigation.goBack();
      } else {
        // navigation.navigate('Dashboard');
        navigation.goBack();
      }
    }
  };

  const onApprovalsBadgePress = () => {
    navigation.navigate('Dashboard', {
      screen: 'Alerts',
      params: {activeTab: 'Pending approvals'},
    });
  };

  return (
    <>
      <SafeAreaView
        edges={[]}
        style={{
          backgroundColor: colorSwatches.primary.color,
          paddingTop: headerTopPadding,
        }}>
        {isAuthorized && (
          <PermissionsBanner
            onPress={() => navigation.navigate(E_NAVIGATION_DESTINATIONS.NOTIFICATION_SETTINGS)
            } />
        )}
        <View style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: Platform.OS === 'ios' ? 0 : 0,
          paddingBottom: Platform.OS === 'ios' ? 0 : 8,
          // elevation: Platform.OS === 'ios' ? 0 : 8,
          backgroundColor: colorSwatches.primary.color,
          paddingRight: 10,
        }}>
          <HStack
            style={{
              flex: 1,
              width: width / 3 + 32,
              alignItems: 'center',
            }}>
            <IconButton
              icon={'arrow-back'}
              size={24}
              style={{ marginTop: 4 }}
              onPress={() => onPress()}
              iconColor={colorSwatches.white.color}
            />
            <Text style={styles.title}>{`${title}`}</Text>
          </HStack>
        </View>
      </SafeAreaView>
      {!!pendingOwnerApprovalsCount && (
        <PendingApprovalsBadge
          pendingApprovals={pendingOwnerApprovalsCount}
          onPress={onApprovalsBadgePress}
        />
      )}
    </>
  );
};

export default Navbar;
